/**
* Migrations for the "siteInfo" object of the event site editor website.
* - Migrate new shared config settings into siteInfo for EventIdentityConfirmation widgets.
*/
export default function siteInfoMigrations(siteInfo) {
  if (siteInfo.sharedConfigs.EventIdentityConfirmation) {
    return siteInfo;
  }
  return {
    ...siteInfo,
    sharedConfigs: {
      ...siteInfo.sharedConfigs,
      EventIdentityConfirmation: {
        instructionalText: { htmlContent: '', editorState: null },
        headerText: { htmlContent: '', editorState: null }
      }
    }
  };
}
